import React from "react";
import styles from "./SubmitButton.module.css";

export default function SubmitButton({children, form}) {
 return (
    <button type="submit" form={form} className={styles.button}>{children}</button>
 )
}